import type { ThemeConfig } from 'antd';
import theme from 'antd/lib/theme';

const { defaultAlgorithm, darkAlgorithm } = theme;

const FeelEatThemeLight: ThemeConfig = {
  algorithm: [defaultAlgorithm],

  components: {
    DatePicker: {
      controlHeight: 40,
      activeBorderColor: '#41614A',
      hoverBorderColor: 'rgba(65, 97, 74, 0.1)',
      colorPrimary: '#41614A',
      cellHoverBg: 'rgba(65, 97, 74, 0.1)',
      cellActiveWithRangeBg: 'rgba(65, 97, 74, 0.1)',
    },
    Select: {
      activeBorderColor: '#41614A',
      hoverBorderColor: 'rgba(65, 97, 74, 0.1)',
      optionSelectedBg: 'rgba(65, 97, 74, 0.1)',
      colorPrimary: '#41614A',
    },
    Layout: {
      bodyBg: '#ffffff',
      siderBg: '#f7f7f7',
      headerBg: '#ffffff',
      headerColor: 'rgb(51, 65, 85)',
      headerPadding: '0 5rem 0 0',
      footerBg: '#ffffff',
      footerPadding: '1.5rem 5rem',
      colorText: 'rgb(0, 21, 41)',
      algorithm: true,
      triggerBg: '#e9e9e9',
      triggerColor: '#000',
    },
    Menu: {
      itemActiveBg: '#e0e0e0',
      itemBg: '#f7f7f7',
      itemColor: '#000',
      itemSelectedBg: '#e0e0e0',
      itemHoverColor: '#000',
      itemSelectedColor: '#000',
      darkItemSelectedBg: '#275747',
      darkItemBg: '#f7f7f7',
      darkItemColor: '#000',
      darkItemHoverBg: '#e0e0e0',
      darkItemHoverColor: '#000',
      popupBg: '#e0e0e0',
      itemBorderRadius: 0,
      colorText: '#000',
      collapsedIconSize: 18,
      groupTitleColor: '#000',
      horizontalItemSelectedBg: '#000',
      dropdownWidth: 180,
      algorithm: true,
    },
    Input: {
      activeBorderColor: '#41614A',
      hoverBorderColor: 'rgba(65, 97, 74, 0.1)',
      colorError: 'rgb(247, 0, 3)',
      colorErrorText: 'rgb(255, 0, 3)',
      colorPrimary: '#41614A',
      lineHeight: 1,
      lineHeightLG: 1,
      controlHeight: 40,
      algorithm: true,
    },
    // Form: {
    //   labelRequiredMarkColor: 'rgb(255, 0, 3)',
    //   colorError: 'rgb(255, 0, 3)',
    //   colorPrimary: 'rgb(15, 23, 42)',
    //   controlHeight: 40,
    //   colorSuccess: 'rgb(80, 161, 40)',
    // },
    Button: {
      defaultBg: '#265247',
      defaultBorderColor: 'rgba(217, 217, 217, 0)',
      defaultColor: 'rgb(148, 163, 184)',
      controlHeight: 40,
    },
    Avatar: {
      colorTextPlaceholder: 'rgb(30, 41, 59)',
      colorTextLightSolid: 'rgb(148, 163, 184)',
    },
    Tabs: {
      cardHeight: 36,
      controlHeightLG: 36,
      fontSize: 12,
      colorBorder: 'rgb(210, 210, 210)',
      colorBorderSecondary: 'rgb(230, 229, 229)',
    },
    Table: {
      headerBg: 'rgba(0 ,0 ,0, 0.03)',
      fontSize: 12,
      lineHeight: 1,
      padding: 10,
      cellFontSize: 12,
      cellFontSizeMD: 12,
      cellFontSizeSM: 12,
      cellPaddingBlock: 8,
      cellPaddingBlockMD: 8,
      cellPaddingInline: 8,
      margin: 8,
      fontWeightStrong: 400,
    },
    Tag: {
      fontSize: 12,
      paddingXXS: 10,
      colorTextDescription: '#000',
      defaultColor: '#000',
      defaultBg: '#e0e0e0',
    },
    Drawer: {
      colorBgElevated: '#fff',
    },
  },
  token: {
    // colorPrimary: '#001529',
    // colorInfo: '#001529',
    // colorLink: '#1677ff',
    fontSize: 12,
  },
};
const FeelEatThemeDark: ThemeConfig = {
  algorithm: [defaultAlgorithm],

  components: {
    DatePicker: {
      controlHeight: 40,
      activeBorderColor: '#41614A',
      hoverBorderColor: 'rgba(65, 97, 74, 0.1)',
      colorPrimary: '#41614A',
      cellHoverBg: 'rgba(65, 97, 74, 0.1)',
      cellActiveWithRangeBg: 'rgba(65, 97, 74, 0.1)',
    },
    Select: {
      activeBorderColor: '#41614A',
      hoverBorderColor: 'rgba(65, 97, 74, 0.1)',
      optionSelectedBg: 'rgba(65, 97, 74, 0.1)',
      colorPrimary: '#41614A',
    },
    Layout: {
      bodyBg: '#ffffff',
      siderBg: '#f7f7f7',
      headerBg: '#ffffff',
      headerColor: 'rgb(51, 65, 85)',
      headerPadding: '0 5rem 0 0',
      footerBg: '#ffffff',
      footerPadding: '1.5rem 5rem',
      colorText: 'rgb(0, 21, 41)',
      algorithm: true,
      triggerBg: '#e9e9e9',
      triggerColor: '#000',
    },
    Menu: {
      itemActiveBg: '#e0e0e0',
      itemBg: '#f7f7f7',
      itemColor: '#000',
      itemSelectedBg: '#e0e0e0',
      itemHoverColor: '#000',
      itemSelectedColor: '#000',
      darkItemSelectedBg: '#275747',
      darkItemBg: '#f7f7f7',
      darkItemColor: '#000',
      darkItemHoverBg: '#e0e0e0',
      darkItemHoverColor: '#000',
      popupBg: '#e0e0e0',
      itemBorderRadius: 0,
      colorText: '#000',
      collapsedIconSize: 18,
      groupTitleColor: '#000',
      horizontalItemSelectedBg: '#000',
      dropdownWidth: 180,
      algorithm: true,
    },
    Input: {
      activeBorderColor: '#41614A',
      hoverBorderColor: 'rgba(65, 97, 74, 0.1)',
      colorError: 'rgb(247, 0, 3)',
      colorErrorText: 'rgb(255, 0, 3)',
      colorPrimary: '#41614A',
      lineHeight: 1,
      lineHeightLG: 1,
      controlHeight: 40,
      algorithm: true,
    },
    // Form: {
    //   labelRequiredMarkColor: 'rgb(255, 0, 3)',
    //   colorError: 'rgb(255, 0, 3)',
    //   colorPrimary: 'rgb(15, 23, 42)',
    //   controlHeight: 40,
    //   colorSuccess: 'rgb(80, 161, 40)',
    // },
    Button: {
      defaultBg: 'rgb(15, 23, 42)',
      defaultBorderColor: 'rgba(217, 217, 217, 0)',
      defaultColor: 'rgb(148, 163, 184)',
      controlHeight: 40,
    },
    Avatar: {
      colorTextPlaceholder: 'rgb(30, 41, 59)',
      colorTextLightSolid: 'rgb(148, 163, 184)',
    },
    Tabs: {
      cardHeight: 36,
      controlHeightLG: 36,
      fontSize: 12,
      colorBorder: 'rgb(210, 210, 210)',
      colorBorderSecondary: 'rgb(230, 229, 229)',
    },
    Table: {
      headerBg: 'rgba(0 ,0 ,0, 0.03)',
      fontSize: 12,
      lineHeight: 1,
      padding: 10,
      cellFontSize: 12,
      cellFontSizeMD: 12,
      cellFontSizeSM: 12,
      cellPaddingBlock: 8,
      cellPaddingBlockMD: 8,
      cellPaddingInline: 8,
      margin: 8,
      fontWeightStrong: 400,
    },
    Tag: {
      fontSize: 12,
      paddingXXS: 10,
      colorTextDescription: '#000',
      defaultColor: '#000',
      defaultBg: '#e0e0e0',
    },
    Drawer: {
      colorBgElevated: '#fff',
    },
  },
  token: {
    // colorPrimary: '#001529',
    // colorInfo: '#001529',
    // colorLink: '#1677ff',
    fontSize: 12,
  },
};

export { FeelEatThemeDark, FeelEatThemeLight };
